import { render } from "./promotionDeactivate.vue?vue&type=template&id=2fb02481&scoped=true"
import script from "./promotionDeactivate.vue?vue&type=script&lang=js"
export * from "./promotionDeactivate.vue?vue&type=script&lang=js"

import "./promotionDeactivate.vue?vue&type=style&index=0&id=2fb02481&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb02481"]])

export default __exports__